import { render } from "./experiance-modal.vue?vue&type=template&id=ed89b5ac"
import script from "./experiance-modal.vue?vue&type=script&lang=js"
export * from "./experiance-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__